import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../model/formBuilderInterface';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiCallService } from '../../../../services/api-call.service';
import debounce  from 'lodash/debounce';
import { CommonService } from 'src/app/modules/shared/services/common.service';
@Component({
  selector: 'app-multiselect',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class FormMultiSelectComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() field: Field;
  @Input() form: FormGroup;
  initialOptions = [];
  @ViewChild('dropdownMultiSelect', { static: false }) dropdownMultiSelectRef;

  constructor(
    private readonly apiCallService: ApiCallService,
    public readonly cs: CommonService
  ) {
    this.onSearchChange = debounce(this.onSearchChange, 300);
  }

  ngOnInit() {
    if (this.field.optionsUrl && this.cs.isBrowser) {
      this.fetchAndSetOptions();
    }
  }

  onSearchChange(event) {
    if (this.field.settings?.allowRemoteDataSearch) {
      this.fetchAndSetOptions(event);
    } else {
      this.localSearch(event);
    }
  }

  localSearch(search = '') {
    this.field.options = this.initialOptions.filter(option => option.label.toLowerCase().includes(search.toLowerCase()));
  }

  closeDropdown() {
    this.field.options = this.initialOptions;
  }
  onItemSelect() {
    if (this.field.settings?.singleSelection)
      this.dropdownMultiSelectRef?.closeDropdown();
  }

  fetchAndSetOptions(search = '') {
    let url = this.field.optionsUrl;
    url = url.replace('[search]', search);
    return this.apiCallService
      .get(url, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ data }) => {
        if (this.field.optionListTransformationFn)
          data = this.field.optionListTransformationFn(data);
        if (!search) {
          this.initialOptions = data;
        }
        this.field.options = data;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
